import {styled} from '@material-ui/core';
import MaterialAddIcon from '@material-ui/icons/Add';

export const AddIcon = styled(MaterialAddIcon)(({theme}) => ({
    background: theme.palette.success.dark,
    borderRadius: '50%',
    color: '#fff',
}));
